export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const MAIN_APP_URL = process.env.REACT_APP_MAIN_APP_URL;
